module.exports = __webpack_public_path__ + "static/img/12.309e404.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/3/zh/12.png
// module id = ZyKw
// module chunks = 0